import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "@/App.jsx";
import Input from "Components/input/Input";
import Button from "Components/button/Button";
import { t } from "i18next";
import WarningBanner from "Components/warningBanner/WarningBanner";
import cx from "classnames";
import RadioButton from "Components/radiobutton/RadioButton";
import CustomerSelect from "Components/customerSelect/CustomerSelect";
import useSWR from "swr";

export default function TypeForm({
  formData,
  stepper,
  setFormFieldValue,
  formErrors,
  onFormCancel,
  setCanHaveFreeAccount,
  nextStep,
  setFormErrors,
  isLoggedUserAdmin,
}) {
  const auth = useContext(AuthContext);

  // if is admin we get the limits later in the wizard, once we know the code
  // const { data: limits } = useSWR(!isLoggedUserAdmin() && `/users/delivery_limits`);

  const { data: limits } = useSWR(() => "/users/delivery_limits?customer_code=" + formData.customer_code);

  useEffect(() => {
    if (!limits) return;
    setCanHaveFreeAccount(limits.can_create_free_account);
  }, [limits]);

  const validateAndNext = async (e) => {
    e.preventDefault();

    if (!formData.description || formData.description.length === 0) {
      return setFormErrors({ description: t("errorMsg.notValid.account.description") });
    }

    if (isLoggedUserAdmin && !formData.customer_code) {
      return setFormErrors({ customer_code: t("errorMsg.required") });
    }

    nextStep();
  };

  return (
    <div className="screenContainer flexAlignCenter">
      {stepper}

      <div className="mt-4 w-full max-w-[--form-page-width]">
        <div className="sectionTitle">{t("delivery.accounts.add.step1.title")}</div>
        <div className="sectionDesc">{t("delivery.accounts.add.step1.desc")}</div>
        <Button docsKey="deliveryAddAccount" className="btnDocsFP" color="docs" sizeSmall>
          button.docs
        </Button>
      </div>

      <form className="block formContainer" method="post" onSubmit={validateAndNext}>
        <div className="flexColumnContainer">
          <div className="formSection">
            {auth.isLoggedUserAdmin() && (
              <CustomerSelect
                className="inputFull2"
                withoutDomainCounter
                label={t("input.label.customer")}
                onChange={(data) => setFormFieldValue({ customer_code: data?.value })}
                errors={formErrors.customer_code}
              />
            )}
          </div>

          <div className="formSection">
            <div className="w-full">
              <div className="!pb-0 settingTitle">{t("delivery.accounts.add.step1.description.title")}</div>
            </div>

            <Input
              className={cx("inputFull2", "mt-3")}
              name="description"
              label={t("delivery.accounts.add.step1.description.desc")}
              wrapperClassName="mt-3"
              placeholder={"My awesome marketing mail"}
              type="text"
              value={formData.description}
              errors={formErrors.description}
              onChange={setFormFieldValue}
              autoComplete="new-password"
              autoCapitalize="off"
              required
            />
          </div>

          <div className="formSection">
            <div className={cx("inputFull2")}>
              <div className="settingTitle">{t("delivery.accounts.add.step1.type.title")}</div>
              <p className="sectionInfo">{t("delivery.accounts.add.step1.type.desc")}</p>
            </div>

            <RadioButton
              className="inputFull2"
              //eslint-disable-next-line
              children={[
                {
                  value: "transactional",
                  label: t("delivery.accounts.add.step1.type.transaction.label"),
                  description: t("delivery.accounts.add.step1.type.transaction.desc"),
                },
                {
                  value: "newsletter",
                  label: t("delivery.accounts.add.step1.type.marketing.label"),
                  description: t("delivery.accounts.add.step1.type.marketing.desc"),
                },
              ]}
              name="type"
              value={formData.type}
              onChange={setFormFieldValue}
            />
          </div>
        </div>

        <div className="flexColumnContainer">
          {formErrors.onForm && (
            <div className="formSection">
              <WarningBanner color="red" msg={formErrors.onForm} />
            </div>
          )}

          <div className="formFooter">
            <Button color="text" type="button" onClick={onFormCancel}>
              button.cancel
            </Button>
            <Button color="accent">button.continue</Button>
          </div>
        </div>
      </form>
    </div>
  );
}
